import React from 'react';
import { Link } from 'react-router-dom';
import MarketOverview from '../components/MarketOverview';
import EconomicCalendarWidget from '../components/EconomicCalendarWidget';
import './Markets.css';

const Markets: React.FC = () => {
  return (
    <div className="markets-page">
      <div className="page-content">
        <div className="page-title">
          <h1>Trading Markets</h1>
          <p>Explore our range of tradable markets with professional analysis</p>
        </div>
        
        <div className="market-grid">
          <div className="market-item">
            <h3 style={{color: '#06b6d4'}}>Forex</h3>
            <p>Currency pairs from major, minor, and exotic markets</p>
            <Link to="/markets/forex" className="btn">Learn More</Link>
          </div>
          
          <div className="market-item">
            <h3 style={{color: '#06b6d4'}}>Indices</h3>
            <p>Trade global stock indices including major market indices</p>
            <Link to="/markets/indices" className="btn">Learn More</Link>
          </div>
          
          <div className="market-item">
            <h3>Commodity</h3>
            <p>Trade precious metals, energies, and agricultural commodities</p>
            <Link to="/markets/commodity" className="btn">Learn More</Link>
          </div>
          
          <div className="market-item">
            <h3>Crypto Currency</h3>
            <p>Trade major cryptocurrencies with professional signals</p>
            <Link to="/markets/crypto" className="btn">Learn More</Link>
          </div>
          
          <div className="market-item">
            <h3>Stocks</h3>
            <p>Trade individual stocks from global markets</p>
            <Link to="/markets/stocks" className="btn">Learn More</Link>
          </div>
        </div>
        
        <MarketOverview />
        
        <div className="economic-calendar-section">
          <h2>Economic Calendar</h2>
          <p>Stay updated with key economic events and announcements that impact global markets</p>
          <div className="calendar-wrapper">
            <EconomicCalendarWidget />
          </div>
        </div>
        
        <div className="market-info">
          <h2>Why Trade With UPM Traders?</h2>
          <p>At UPM Traders, we provide professional trading signals and market analysis for all major markets. Our experienced traders and analysts ensure that you get the best possible trading opportunities with risk management strategies.</p>
          
          <div className="market-features">
            <div className="feature">
              <h3>Real-Time Analysis</h3>
              <p>Get real-time market analysis and updates on all major trading sessions</p>
            </div>
            <div className="feature">
              <h3>Risk Management</h3>
              <p>Learn proper risk management techniques to protect your capital</p>
            </div>
            <div className="feature">
              <h3>Expert Insights</h3>
              <p>Access insights from professional traders with years of experience</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Markets;